export default __webpack_public_path__ + "static/media/atm.287c5a4a.jpg";